/* eslint-disable import/no-named-as-default-member */
import amplitude, { AmplitudeClient, Callback, LogReturn } from "amplitude-js";

import config from "./config/index";

// @types/amplitude-js don't match the latest version of the library, so we need to change the logEvent signature to accept an 'onError' callback
interface ExtendedAmplitudeClient extends AmplitudeClient {
  logEvent: (
    event: string,
    data?: any, // eslint-disable-line @typescript-eslint/no-explicit-any
    successCallback?: Callback | undefined,
    errorCallback?: Callback | undefined
  ) => LogReturn;
}

export const initAmplitude = (): void => {
  amplitude.getInstance().init(config.AMPLITUDE_API_KEY);
};

export const setAmplitudeUserId = (id: string): void => {
  amplitude.getInstance().setUserId(id);
};

export const setAmplitudeUserProperties = (properties: unknown): void => {
  amplitude.getInstance().setUserProperties(properties);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sendAmplitudeEvent = <EventProperties = any>(
  eventDetails: { element: string; action: string },
  eventProperties?: EventProperties,
  successCallback?: () => void,
  errorCallback?: () => void
): void => {
  const { element, action } = eventDetails;
  (amplitude.getInstance() as ExtendedAmplitudeClient).logEvent(
    `Portal - Connector Health - ${element} - ${action}`,
    eventProperties,
    successCallback,
    errorCallback
  );
};
